

export default class FiltroBusquedaConst {
  static FILTROBUSQUEDA_IGUAL = 'filterbusqueda-eq';
  static FILTROBUSQUEDA_CONTIENE = 'filterbusqueda-inc';

  static FILTROBUSQUEDA_NONULO = 'filterbusqueda-nonull';
  static FILTROBUSQUEDA_NULO = 'filterbusqueda-null';

}
